(() => {
  const close = button => { button.setAttribute('aria-expanded', 'false'); const panel = document.getElementById(button.getAttribute('aria-controls')); if(panel) panel.hidden = true; };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pr-nav-toggle]');
    document.querySelectorAll('[data-pr-nav-toggle]').forEach(other => { if(other !== button && !other.parentElement.contains(event.target)) close(other); });
    if (!button) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
  });
  document.addEventListener('keydown', event => {
    if(event.key !== 'Escape') return;
    document.querySelectorAll('[data-pr-nav-toggle][aria-expanded="true"]').forEach(button => { close(button); button.focus(); });
  });
})();
